import { Component, Inject, Optional } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BrowserStorage } from '../../../../utils/shared-services/browser-storage.service';
import { CaptionService } from '../../../../utils/shared-services/caption.service';
import { WidgetDescriptionDialog } from '../../components/dialogs/widget-description-dialog.component';

@Component({
    selector: 'wid001',
    templateUrl: 'src/app/features/store-portal/widgets/templates/wid-001.html',
    standalone: false
})
export class Wid001 {
    public dateSelectedValue: string;
    public captions: any;
    public isTimedOut: boolean = false;
    public areDatapointsInvalid: boolean = true;
    public invalidDatapoints: any[] = [];
    public datapoints: any[] = [];

    public headers: string[];
    public labels: string[];
    public datasets: any;

    public storeName: any;
    public currencyCode: any;
    public storeInfo: any;
    public storeStatus: number = -1;

    constructor(
        @Inject(Object) @Optional() private widget: any,
        @Inject(CaptionService) private captionService,
        @Inject(BrowserStorage) private browserStorage: BrowserStorage,
        @Inject(MatDialog) private dialog: MatDialog
    ) {
        this.captions = this.captionService.captions;
        this.headers = [this.captions.category, this.captions.amount];
        this.labels = [this.captions.transCountFront, this.captions.netSalesFront, this.captions.finalSalesFront];

        this.storeName = this.browserStorage.getSessionstorage('portalData', null)?.StoreName;
        this.currencyCode = this.browserStorage.getSessionstorage('portalData', null)?.CurrencyCode;
        this.dateSelectedValue = this.browserStorage.getSessionstorage('widgetSelectedDate', null);
        if (this.widget?.id) {
            this.datapoints = this.browserStorage.getSessionstorage(this.widget.id, null);
        }
    }

    openInfoDialog() {
        this.dialog.open(WidgetDescriptionDialog, {
            panelClass: 'app-full-bleed-dialog',
            maxWidth: '95vw',
            data: {
                widgetID: this.widget.id,
            },
        });
    }

    ngOnInit() {
        // to change animation on wid-000
        if (this.widget && this.widget.isTimedOut) {
            this.isTimedOut = true;
            return;
        }

        if (!this.widget || !this.widget.isLoaded) {
            return;
        }

        // Verify datapoints, making sure they are not null or undefined
        this.areDatapointsInvalid = false;
        for (let i = 0; i < this.widget.data.length; i++) {
            if (!this.widget.data[i]) {
                this.areDatapointsInvalid = true;
                this.invalidDatapoints.push(this.datapoints[i]);
            }
        }
        if (this.areDatapointsInvalid) {
            return;
        }

        this.storeInfo = this.widget.data[0].Record;
        // -1 -> no store data for this open date, 0 -> store is closed, 1 -> store is open
        this.storeStatus = -1;
        if (this.storeInfo) {
            this.storeStatus = this.storeInfo.TIMEEND ? 0 : 1;
        }

        let salesData = this.widget.data[1].Record;
        if (!salesData) {
            return;
        }

        this.datasets = [
            {
                data: [
                    salesData.TRCOUNT ? salesData.TRCOUNT : '0',
                    salesData.NETTOTAL ? salesData.NETTOTAL.toFixed(2) : '0.00',
                    salesData.FINALTOTAL ? salesData.FINALTOTAL.toFixed(2) : '0.00',
                ],
            },
        ];
    }
}
